import { ActionFeedback, ActionFeedbackBanner } from "thrive-components";


const DeletedBanner = ({ isDeleted, message} : { isDeleted?: boolean, message: string}) => {
    if (!isDeleted) {
        return <></>
    }
    return (
        <ActionFeedbackBanner feedbackType={ActionFeedback.DELETED} feedbackMessage={message || "Deleted"} />
    );
};

export default DeletedBanner